module.exports = __webpack_public_path__ + "static/10400556_21565067223_103_n-e40321f04a0548831d4195e78ae17b36.jpg";